import { UseQueryResult } from '@tanstack/react-query';

export const useCombineStates = (results: UseQueryResult[]) => {
  return {
    isLoading: results.some((result) => result.isLoading),
    isError: results.some((result) => result.isError),
    isFetching: results.some((result) => result.isFetching),
    errorMessage: results.find((result) => result.error)?.error.message || '',
  };
};
